import React, { ReactNode, useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

// Function to get session details from sessionStorage
const sessionDetails = (): string | null => {
  return sessionStorage.getItem(`LoginDetails`);
};

// Define the prop types for PrivateRoute
interface PrivateRouteProps {
  children: ReactNode;  // This represents the child components passed to PrivateRoute
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const [auth, setAuth] = useState<boolean>(false);

  // Check if session data is available
  const tokenData = sessionDetails();

  return tokenData ? <>{children}</> : <Navigate to="/login" />;
}

export default PrivateRoute;
